import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";

import AutoCard from "../components/AutoCard";

import "../styles/Autos.css";

export default function Autos() {

  const navigate = useNavigate();

  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [availableOnly, setAvailableOnly] = useState(false);

  useEffect(() => {

    const q = query(
      collection(db, "autos"),
      where("verified", "==", true)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {

        const list = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setDrivers(list);

        setLoading(false);

      },
      (err) => {

        console.error(err);

        setLoading(false);

      }
    );

    return unsubscribe;

  }, []);

  const filteredDrivers = useMemo(() => {

    return drivers.filter(driver => {

      const text = search.toLowerCase();

      const matchesSearch =
        driver.driverName?.toLowerCase().includes(text) ||
        driver.serviceArea?.toLowerCase().includes(text) ||
        driver.autoNumber?.toLowerCase().includes(text);

      const matchesAvailability =
        !availableOnly || driver.available;

      return matchesSearch && matchesAvailability;

    });

  }, [drivers, search, availableOnly]);

  return (

    <div className="autos-page">

      <div className="autos-header">

        <div>

          <h2>🚖 Local Auto</h2>

          <p>
            Find nearby auto drivers
          </p>

        </div>

        <button
          className="join-auto-btn"
          onClick={() => navigate("/join-auto")}
        >
          Join as Driver
        </button>

      </div>

      <input
        className="search-box"
        type="text"
        placeholder="Search by driver, area or auto number..."
        value={search}
        onChange={(e) =>
          setSearch(e.target.value)
        }
      />

      <label className="available-filter">

        <input
          type="checkbox"
          checked={availableOnly}
          onChange={() =>
            setAvailableOnly(!availableOnly)
          }
        />

        Available Only

      </label>

      {loading ? (

        <div className="loading">

          Loading drivers...

        </div>

      ) : filteredDrivers.length === 0 ? (

        <div className="empty">

          <h3>No Drivers Found</h3>

          <p>

            No auto drivers match your search.

          </p>

        </div>

      ) : (

        <div className="autos-grid">

          {filteredDrivers.map(driver => (

            <AutoCard
              key={driver.id}
              driver={driver}
            />

          ))}

        </div>

      )}

    </div>

  );

}